import { betSlipModule } from './betslip';
import {
    sportOfferExperimentsStore,
    SportOfferExperimentsStore,
} from './experiment/experimentsStore';
import favourites, { FavouritesState } from './favourites/favouritesIndex';
import marketFilters from './marketFilters/index';
import { MarketFiltersState } from './marketFilters/types';
import markets from './markets/index';
import { MarketsState } from './markets/types';
import search, { ISearchState } from './search/searchIndex';
import sportPage, { ISportPageState } from './sportPage/sportPageIndex';
import sports, { ISportsState } from './sports/sportsIndex';
import { BetSlipState } from '../betSlip/types';

export type ISportOfferState = {
    sports: ISportsState;
    marketFilters: MarketFiltersState;
    search: ISearchState;
    betSlip: BetSlipState;
    favourites: FavouritesState;
    markets: MarketsState;
    experiments: SportOfferExperimentsStore;
} & ISportPageState; // ISportPageState is not namespaced;

export default {
    modules: {
        sports,
        marketFilters,
        search,
        favourites,
        sportPage,
        betSlip: betSlipModule,
        markets,
        experiments: sportOfferExperimentsStore,
    },
    namespaced: true,
};
